import React from "react";
import { useTranslation } from "react-i18next";

/**
 * "Which table?" — chips 1..table_count, one selectable.
 *
 * Only ever rendered when the venue is TABLE service AND the guest arrived
 * without a table in the URL (an item QR photographed off a screen). A per-table
 * QR pre-fills the number and this disappears entirely: asking someone to
 * confirm a table they already told us is the second scan the architecture
 * explicitly rules out.
 *
 * When the venue never configured a table count we fall back to a plain input
 * rather than render a list of zero chips — a venue with no count set is exactly
 * the venue whose guests still need to say where they are sitting.
 *
 * Numbers are forced LTR. A table grid is physical, not linguistic: in Arabic
 * the digits stay Latin and the row still runs the way the room does.
 */
export default function TablePicker({ tableCount, value, onChange, invalid }) {
  const { t } = useTranslation();

  const hasChips = Number.isFinite(tableCount) && tableCount > 0;

  return (
    <section className="ss-block">
      <h2 className="ss-block-title">{t("scan_stay.order.which_table")}</h2>

      {hasChips ? (
        <div
          className={`ss-tables${invalid ? " invalid" : ""}`}
          role="radiogroup"
          aria-label={t("scan_stay.order.which_table")}
          dir="ltr"
        >
          {Array.from({ length: tableCount }, (_, i) => String(i + 1)).map((n) => (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={value === n}
              className={`ss-table-chip${value === n ? " on" : ""}`}
              onClick={() => onChange(value === n ? "" : n)}
            >
              {n}
            </button>
          ))}
        </div>
      ) : (
        <div className="ss-field">
          <label htmlFor="ss-table">{t("scan_stay.order_table_label")}</label>
          <input
            id="ss-table"
            type="text"
            inputMode="numeric"
            dir="ltr"
            className={invalid ? "invalid" : undefined}
            value={value}
            onChange={(e) => onChange(e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 8))}
            placeholder={t("scan_stay.order_table_ph")}
          />
        </div>
      )}
    </section>
  );
}
